<template>
  <div class="search-container">
    <div class="search-section" v-for="(pTag, pIndex) in tags" :key="pIndex">
      <div class="search-title">{{pTag.type_name}}：</div>
      <ul class="search-options">
        <li  class="search-option" v-for="(tag, index) in pTag.tags" :key="index">
          <span
            @click="switchOptions(
              pTag.type_key,
              tag.id,
              !isNaN(Number(tag.pid)) ? tag.pid : '')
            "
            :class="{'active':Number(tag.id)===Number(curTag[pTag.type_key])}">{{tag.name||tag.title}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// import { mapMutations, mapState } from 'vuex'
export default {
  props: [
    'tags',
    'curTag'
  ],
  data () {
    return {
    }
  },
  methods: {
    switchOptions (pTagkey, tagid, tagpid) {
      this.$emit('select', pTagkey, tagid, tagpid)
    }
  },
  computed: {
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.search-container
  background-color: #fff
  padding: 29px 52px
  border-radius: 5px
  .search-section
    display: flex
    // align-items: center
    color: #353535
    margin-bottom: 23px
    &:last-child
      margin-bottom: 0
    // &:nth-child(3)
    //   padding-top: 17px
    //   border-top: 1px solid rgba(136, 136, 136, .1)
    .search-title
      font-size: 16px
      line-height: 34px
      width: 82px
      text-align: left
      font-weight: 500
      margin-right: 10px
      flex-shrink: 0
      position: relative
      &::after
        display: none
        position: absolute
        content: ''
        right: 0
        top: 4px
        height: 16px
        width: 2px
        background-color: rgba(53, 53, 53, .6)
    .search-options
      cursor: pointer
      display: flex
      flex-wrap: wrap
      .search-option
        font-size: 16px
        line-height: 24px
        margin: 0 4px
        text-align: center
        position: relative
        padding: 5px 0
        &::after
          display: none
          position: absolute
          content: ''
          right: 0
          top: 4px
          height: 16px
          width: 2px
          background-color: rgba(53, 53, 53, .1)
        span
          padding: 2px 12px
          &.active
            background-color: rgba(215, 179, 117, .2)
            border-radius: 2px
            color: $primary3
            font-weight: 500
</style>
